
globalThis.WDConfig = {
  panes: {
    breakpoint: 768
  }
};

import './funcs/wdc.js';
import './funcs/prototypes/cursor.js';
import './funcs/prototypes/date.js';
import './funcs/prototypes/number.js';
import './funcs/prototypes/storage.js';
import './funcs/prototypes/string.js';

export * from './core/index.js';
export * from './gui/index.js';


